export enum HousingTypeEnum {
  Hus,
  Rækkehus,
  Lejlighed,
  Fritidshus,
  'Ikke Angivet'
}
